export const urlApi = 'https://api.mercadopago.com/v1/'
export const idCliente = 'AfyPx2jcw5xKNXBnaQG5vmdK5JMjrq-Zo6kMYBrBzDhXCuYRIx2fwY-9tuE7Gj6J61enBbPuxls8w7YS'
// export const idCliente = 'Ac7bhu53mNQFX-tj95dkw4jwokCHrr6HDm96kUKM2wkwjI0HfEwdWQcHgzVvUQbzLF42TQhsEeX5jWK6' //PRUEBA
export const apiDolar = 'https://deperu.com/api/rest/cotizaciondolar.json'
